

import { Building2, Briefcase, Users, Award } from 'lucide-react';
import { Card } from '@/components/ui/card';

const careers = [
  {
    title: 'Software Engineer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Full-time',
    description: 'Join our engineering team to build the future of EV charging infrastructure.',
  },
  {
    title: 'Product Manager',
    department: 'Product',
    location: 'San Francisco, CA',
    type: 'Full-time',
    description: 'Lead product strategy and development for our charging network platform.',
  },
  {
    title: 'Customer Success Manager',
    department: 'Operations',
    location: 'Remote',
    type: 'Full-time',
    description: 'Help our charging station hosts and EV drivers succeed on our platform.',
  }
];

const Careers = () => {
  return (
    <div className="container py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Join Our Mission</h1>
        <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
          Help us build the future of sustainable transportation by making EV charging accessible everywhere.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
        <Card className="p-6 text-center">
          <Building2 className="w-12 h-12 mx-auto mb-4 text-primary" />
          <h3 className="font-semibold mb-2">Fast-Growing Startup</h3>
          <p className="text-muted-foreground">Be part of a rapidly expanding team making real impact</p>
        </Card>
        <Card className="p-6 text-center">
          <Users className="w-12 h-12 mx-auto mb-4 text-primary" />
          <h3 className="font-semibold mb-2">Inclusive Culture</h3>
          <p className="text-muted-foreground">Work in a diverse and supportive environment</p>
        </Card>
        <Card className="p-6 text-center">
          <Award className="w-12 h-12 mx-auto mb-4 text-primary" />
          <h3 className="font-semibold mb-2">Competitive Benefits</h3>
          <p className="text-muted-foreground">Great compensation and comprehensive benefits package</p>
        </Card>
        <Card className="p-6 text-center">
          <Briefcase className="w-12 h-12 mx-auto mb-4 text-primary" />
          <h3 className="font-semibold mb-2">Career Growth</h3>
          <p className="text-muted-foreground">Opportunities for learning and advancement</p>
        </Card>
      </div>

      <h2 className="text-3xl font-bold mb-8 text-center">Open Positions</h2>
      <div className="space-y-6 max-w-4xl mx-auto">
        {careers.map((job, index) => (
          <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-xl font-semibold mb-2">{job.title}</h3>
                <p className="text-muted-foreground mb-4">{job.description}</p>
                <div className="flex gap-4">
                  <span className="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">
                    {job.department}
                  </span>
                  <span className="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">
                    {job.location}
                  </span>
                  <span className="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">
                    {job.type}
                  </span>
                </div>
              </div>
              <button className="bg-primary text-primary-foreground px-4 py-2 rounded-md hover:bg-primary/90 transition-colors">
                Apply Now
              </button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Careers;
